<div class="info-container">
    <div class="two-columns-2-1" *ngIf="organisation">
        <div>
            <h1 style="font-weight: 600;">Anbieter Details </h1>
            <!-- disabled form fields just for display -->
            <div *ngIf="!changeOrganisationDetailsMode" class="leftColumn">
                <div class="prevent-grid-blowout">
                    <mat-form-field>
                        <input matInput placeholder="Name der Organisation" [value]="organisation.organisationName"
                            disabled />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="Straße" [value]="organisation.address.street" disabled />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="Postleitzahl" [value]="organisation.address.postalCode" disabled />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="Website" [value]="organisation.website" disabled />
                    </mat-form-field>
                </div>
                <div class="prevent-grid-blowout">
                    <mat-form-field>
                        <input matInput placeholder="Art der Organisation" [value]="getOrgaType()" disabled />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="Hausnummer" [value]="organisation.address.streetAdditional"
                            disabled />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="Ort" [value]="organisation.address.city" disabled />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="Kurzbezeichnung" [value]="organisation.domain" disabled />
                    </mat-form-field>
                </div>
            </div>

            <form [formGroup]="editForm" *ngIf="changeOrganisationDetailsMode">
                <div class="columns-50-50">
                        <mat-form-field>
                            <mat-label>Name der Organisation</mat-label>
                            <input matInput formControlName="name" required maxlength="161"
                            [errorStateMatcher]="orgaNameErrorStateMatcher"
                            (blur)="trimField('name')"/>
                            <mat-error>
                                {{ utilService.getFormControlErrorMessage(editName, {includeMinLength: true}) }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Art der Organisation</mat-label>
                            <mat-select formControlName="type" multiple required>
                                <mat-option value="PRODUCT_PROVIDER">
                                    Produktanbieter
                                </mat-option>
                                <mat-option [disabled]="!isUserPlatformAdmin()" value="PRODUCT_TYPE_ASSOCIATION">
                                    Fachgruppe
                                </mat-option>
                                <mat-option [disabled]="!isUserPlatformAdmin()" value="CERTIFICATION_PROVIDER">
                                    Zertifizierungsanbieter
                                </mat-option>
                                <mat-option [disabled]="!isUserPlatformAdmin()" value="CERTIFICATION_OFFICE">
                                    Zertifizierungsdienstleister
                                </mat-option>
                                <mat-option value="DATASPACE_PARTICIPANT">
                                    Datenraum Participant
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="type.hasError('required')">
                                Dieses Feld darf nicht leer sein.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Straße</mat-label>
                            <input matInput formControlName="street" required (blur)="trimField('street')"/>
                            <mat-error *ngIf="editStreet.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="!editStreet.hasError('required') && editStreet.hasError('specialCharFound')">
                                Bitte keine Sonderzeichen benutzen.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Hausnummer</mat-label>
                            <input matInput formControlName="hNr" required (blur)="trimField('hNr')"/>
                            <mat-error *ngIf="editHNr.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="editHNr.hasError('maxlength')">Hausnummer ist zu lang</mat-error>
                            <mat-error *ngIf="!editHNr.hasError('maxlength') && editHNr.hasError('pattern')">
                                Bitte gültige Hausnummer eingeben
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Postleitzahl</mat-label>
                            <input matInput formControlName="postalCode" required (blur)="trimField('postalCode')"/>
                            <mat-error *ngIf="editPostalCode.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Ort</mat-label>
                            <input matInput formControlName="city" required (blur)="trimField('city')"/>
                            <mat-error *ngIf="editCity.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="!editCity.hasError('required') && editCity.hasError('pattern')">
                                Bitte mindestens zwei Zeichen eingeben und das erste Zeichen bitte groß schreiben
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Website</mat-label>
                            <input matInput formControlName="url" type="url" (blur)="trimField('url')"/>
                            <mat-error *ngIf="editUrl.hasError('websiteLength')">
                                Die Website darf maximal 60 Zeichen lang sein
                            </mat-error>
                            <mat-error *ngIf="editUrl.hasError('invalidUrl') && !editUrl.hasError('websiteLength')">
                                Bitte eine valide Website angeben
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Telefonnummer</mat-label>
                            <input matInput formControlName="phoneNumber"
                                autocomplete="tel"
                                (blur)="checkPhonenumber()"/>
                            <mat-error *ngIf="editPhoneNumber.invalid">
                                Bitte eine gültige Telefonnummer angeben
                            </mat-error>
                        </mat-form-field>
                        <!-- <mat-form-field>
                            <mat-label>Kurzbezeichnung</mat-label>
                            <input matInput formControlName="domain" required (blur)="trimField('domain')"/>
                            <span matPrefix>@</span>
                            <mat-error *ngIf="editDomain.hasError('required')">
                                Bitte geben Sie eine Kurzbezeichnung ein.
                            </mat-error>
                        </mat-form-field> -->

                </div>
                <div *ngIf="!changeOrganisationDetailsMode">
                    <h4 class="disabled">Beschreibung</h4>
                    <p class="disabled description" [innerHTML]="organisation.description"></p>
                </div>
                <div *ngIf="changeOrganisationDetailsMode">
                    <app-text-editor [(editorText)]="organisationDetails.description"
                        (textValidityChange)="onDescriptionValidityChange($event)"></app-text-editor>
                </div>
            </form>
            <div class="buttons" style="margin-bottom: 2vh;">
                <button *ngIf="
                        !changeOrganisationDetailsMode &&
                        this.isUserAdminOfOrganisationOrPlattformAdmin()
                    " matButton="elevated" color="primary" (click)="onChangeOrganisationDetailsToggle()">
                    Bearbeiten
                </button>
                <!---- && organisationService.activeOrganisationMembership.role==='ADMIN' -->

                <button *ngIf="
                        !changeOrganisationDetailsMode &&
                        this.isUserAdminOfOrganisationOrPlattformAdmin()
                    " matButton="elevated" color="warn" (click)="onPressAskForDeleteConfirm()">
                    Organisation löschen
                </button>
                <!---- && organisationService.activeOrganisationMembership.role==='ADMIN' -->

                <button *ngIf="changeOrganisationDetailsMode" matButton="elevated" color="warn"
                    (click)="onChangeOrganisationDetailsToggle()">
                    Abbrechen
                </button>
                <button *ngIf="changeOrganisationDetailsMode" matButton="elevated" color="primary"
                    [disabled]="!editForm || editForm.invalid || !isDescriptionValid"
                    (click)="onChangeOrganisationDetailsConfirm()">
                    Speichern
                </button>
            </div>
        </div>
        <app-logo [fileId]="
                changeOrganisationDetailsMode
                    ? organisationDetails.fileId
                    : organisation.fileId
            " [editDisabled]="!changeOrganisationDetailsMode"
            (logoChanged)="organisationDetails.fileId = $event"></app-logo>
    </div>

    <div>
        <!-- TO DO: check with PO if these components are obsolete and delete all unnecessary variables -->
        <!-- <app-hexagon-button-text-icon

        *ngIf="hasContacts"
        [text]="'Kontakte der Organisation'"
        [icon]="'/assets/img/icons/Organisation_hinzufuegen.png'"
        (click)="organisationContactsToggle()"
      >
      </app-hexagon-button-text-icon> -->

        <!-- <app-organisation-contact-overview
        (sent)="organisationContactsToggle()"
        [isViewForAdmin]="isUserAdminOfOrganisationOrPlattformAdmin()"
      ></app-organisation-contact-overview> -->
        <app-create-contact-form *ngIf="organisation" [orga]="organisation"
            [contacts]="organisation?.contacts || []"></app-create-contact-form>
    </div>
</div>
